import { Radio, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import x from '@coursera/assets/icons/x-no-circle.svg';

import styles from './radio-button-group.module.scss';

/**
 * A grouping of buttons that aesthetically resemble MUI-Radio Group.
 *
 * Don't use this in a real form.
 *
 */
function RadioButtonGroup({ options, disabled, selection, selected, incorrect }) {
  return (
    <>
      {options.map((option) => (
        <button
          key={option.id}
          disabled={disabled || incorrect.includes(option.id)}
          className={`${styles.button} ${
            disabled || incorrect.includes(option.id) ? styles.incorrect : ''
          }`}
          onClick={() => selected(option.id)}
        >
          <Typography component="span">{option.label}</Typography>

          {!incorrect.includes(option.id) ? (
            <Radio
              color="primary"
              tabIndex="-1"
              aria-hidden="true"
              checked={selection === option.id}
            />
          ) : (
            <img src={x} alt="" />
          )}
        </button>
      ))}
    </>
  );
}

RadioButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    }),
  ),
  disabled: PropTypes.bool,
  selection: PropTypes.string,
  selected: PropTypes.func,
  incorrect: PropTypes.array,
};

export default RadioButtonGroup;
